export default __webpack_public_path__ + "static/media/pro-elevate-blk-1.47c1ea01.png";